import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
const { defineMultiStyleConfig: e, definePartsStyle: r } = o([
  "container",
  "dropzone",
  "listitem"
]), t = r({
  container: {},
  dropzone: {
    width: "100%",
    height: "324px",
    borderWidth: "1px",
    borderStyle: "dashed",
    borderRadius: "lg",
    borderColor: "gray.200",
    p: 10,
    backgroundColor: "gray.50",
    '&[data-dragActive="true"]': {
      backgroundColor: "gray.100"
    },
    _hover: {
      backgroundColor: "gray.100"
    },
    '&[data-invalid="true"]': {
      borderWidth: "2px",
      borderColor: "red.500",
      borderStyle: "solid"
    },
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed",
      _hover: {
        backgroundColor: "gray.50"
      }
    },
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  },
  listitem: {
    gap: 4,
    alignItems: "center",
    p: 4,
    borderBottom: "1px solid var(--sgi-colors-gray-200)",
    _focusVisible: {
      outline: "none",
      boxShadow: "outline"
    }
  }
}), i = e({
  baseStyle: t
});
export {
  i as default
};
